export type Options = {
    url: string
    title?: string
    width?: number
    height?: number
    left?: number
    top?: number
    resizable?: boolean
    scrollbars?: boolean
    toolbar?: boolean
    menubar?: boolean
    location?: boolean
    status?: boolean
}

export function open(options: Options): Window | null {
    const { url, title = '_blank', ...rest } = options
    return window.open(url, title, buildFeatures(rest))
}

type Features = Omit<Options, 'url' | 'title'>

function buildFeatures(features: Features): string {
    const { width = 750, height = 780, left, top, ...flags } = features

    const computedLeft = left ?? Math.round((screen.width - width) / 2)
    const computedTop = top ?? Math.round((screen.height - height) / 2)

    const parts: string[] = [`width=${width}`, `height=${height}`, `left=${computedLeft}`, `top=${computedTop}`]

    for (const [key, value] of Object.entries(flags)) {
        if (value !== undefined) {
            parts.push(`${key}=${value ? 1 : 0}`)
        }
    }

    return parts.join(',')
}
